export default __webpack_public_path__ + "static/media/logo_tss.98afb97d.svg";